import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { Row, Col } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import { TreeTable } from 'primereact/components/treetable/TreeTable';
import { Column } from 'primereact/components/column/Column';
import { translate } from "../base/Translation";

export default class StatisticView extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_statistic: "/statistic/fetch/:statistic?withStats=:withStats",
			export_statistic: "/statistic/export/:statistic",
		});

		this.state = {
			statistic: false,
			weaves: [],
			selectedWeave: null,
			expanded: false
		};
	}

	fetchData() {
		this.api.request({
			route: "get_statistic",
			params: { statistic: this.props.params.statisticID, withStats: true },
			success: (statistic) => {

				for (let formIndex in statistic.results) {
					let form = statistic.results[formIndex];

					for (let sectionIndex in form.children) {
						let section = form.children[sectionIndex];

						for (let groupIndex in section.children) {
							let group = section.children[groupIndex];

							if (group.data.name === "-") {
								statistic.results[formIndex].children[sectionIndex].children = group.children;
								break;
							}

						}

					}
				}


				this.setState({ statistic });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	/*
	 *
	 * Render methods
	 *
	 */


	render() {

		if (!this.state.statistic) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			)
		}

		return (

			<Page>
				<PageHeader title={this.state.statistic.name} right={() => {
					return <button className="btn btn-primary btn-sm pull-right" onClick={() => {
						this.api.request({
							route: "export_statistic",
							params: { statistic: this.props.params.statisticID },
							success: (response) => {
								window.location.href = response.file;
							}
						});
					}}><i className="fa fa-download" /> {translate("Export do .XLSX")}</button>
				}} />
				<PageBody>
					<Row>
						<Col lg={12}>
							<div style={{ paddingBottom: "1rem" }}>
								<span>{translate("Testy zahrnuté podľa pravidiel:")} </span>
								{this.state.statistic.tests.map((test, index) => {
									return <span key={index}>{test + (index < this.state.statistic.tests.length - 1 ? ", " : "")}</span>
								})}
							</div>
						</Col>
						<Col lg={12}>
							<div className="form-group pull-right">
								<button className="btn btn-primary" onClick={() => {

									let statistic = this.state.statistic;

									statistic.results.forEach(form => {
										form.expanded = !this.state.expanded;
										form.children.forEach(section => {
											section.expanded = !this.state.expanded;
											section.children.forEach(group => {
												group.expanded = !this.state.expanded;
												group.children.forEach(question => {
													question.expanded = !this.state.expanded;
												});
											});
										});
									});

									this.setState({ expanded: !this.state.expanded, statistic });

								}} >{this.state.expanded ? translate("Zabaliť všetko") : translate("Rozbaliť všetko")}</button>
							</div>
						</Col>
						<Col lg={12}>
							<TreeTable value={this.state.statistic.results} key={this.state.expanded ? "expandedTreeView" : "collapsedTreeView"}>
								<Column field="type" header={translate("Typ")} style={{ width: "150px", borderBottom: "1px solid #e1e1e1", textAlign: "left" }}></Column>
								<Column field="name" header={translate("Názov")} style={{ borderBottom: "1px solid #e1e1e1", textAlign: "left" }}></Column>
								<Column field="answerCount" header={translate("Počet")} style={{ width: "150px", borderBottom: "1px solid #e1e1e1", textAlign: "center" }}></Column>
								<Column field="percent" header={translate("Percento")} style={{ width: "150px", borderBottom: "1px solid #e1e1e1", textAlign: "center" }}></Column>
							</TreeTable>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}





// WEBPACK FOOTER //
// ./src/modules/statistic/StatisticView.jsx